import type { ReactNode } from "react";
import { Badge } from "./components";
import DataCoverageLayout from "./layout";

const markets = [
  "Cboe Futures Exchange", "CFFEX", "cmdty Cash Grain Prices", "cmdty Grain Indexes",
  "cmdty Refined Fuels", "cmdty Scrap Metal Indexes", "cmdtyStats", "CME Group - CBOT",
  "CME Group - CME", "CME Group - Comex", "CME Group - Nymex", "Dalian Commodity Exchange",
  "DGCX - Dubai", "EEX Commodities", "Eurex", "Euronext Commodities (MATIF)",
  "Euronext Index Futures", "Hong Kong Futures Exchange", "ICE Canada", "ICE Europe",
  "ICE Liffe", "ICE US", "Kansas City Board of Trade", "London Metal Exchange",
  "MATBA", "MEFF Derivatives", "Minneapolis Grain Exchange", "NASDAQ OMX Nordic",
  "NCDEX", "NZX Derivatives", "ROFEX", "Shanghai - INE", "Shanghai Futures Exchange",
  "TAIFEX", "Thailand Futures Exchange", "TMX Futures", "TOCOM", "Zhengzhou Commodity Exchange",
];

export default function CommoditiesPage(): ReactNode {
  return (
    <DataCoverageLayout>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
          <tr className="border-b border-gray-200">
            {["Market", "Historical", "Delayed", "Real Time", "Level 2"].map(h => (
              <th key={h} className="text-left py-2 px-3 text-xs font-semibold text-gray-500 uppercase tracking-wide whitespace-nowrap">{h}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          {markets.map(market => (
            <tr key={market} className="border-b border-gray-100 hover:bg-gray-50">
              <td className="py-2 px-3 font-medium text-gray-800 whitespace-nowrap">{market}</td>
              <td className="py-2 px-3"><Badge value="A"/></td>
              <td className="py-2 px-3"><Badge value="A"/></td>
              <td className="py-2 px-3"><Badge value="A"/></td>
              <td className="py-2 px-3"><Badge value="N"/></td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>
    </DataCoverageLayout>
  );
}
